<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">부서관리</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">부서 수정</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                부서 수정 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 80px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">부서명</th>
                  <td>
                    <input type="text" title="부서명" class="md" v-model="deptNm" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">부서설명</th>
                  <td>
                    <textarea name="" id="" style="resize: none; min-height: 180px" v-model="deptDc"></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class="btnArea">
          <button class="btn border" @click="$router.push('departmentlist')">목록</button>
          <button class="btn gray" @click="goBackConfirm">취소</button>
          <button class="btn blue" @click="updateBtn">저장</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';

export default {
  data() {
    return {
      deptId: '',
      deptNm: '',
      deptDc: '',
      submitStatus: '',
    };
  },

  created() {
    const data = this.$route.params.data;
    this.deptNm = data.deptNm;
    this.deptDc = data.deptDc;
    this.deptId = data.deptId;
  },

  methods: {
    async updateBtn() {
      let apiParams = new FormData();
      apiParams.append('deptId', this.deptId);
      apiParams.append('deptNm', this.deptNm);
      apiParams.append('deptDc', this.deptDc);
      await axios('post', '/api/dept/updateAction.json', apiParams)
        .then(response => {
          let message = response.data.message;
          alert(message);
          this.$router.push('departmentlist');
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    goBackConfirm() {
      this.$confirm({
        message: `취소하시겠습니까?`,
        button: {
          no: '아니오',
          yes: '예',
        },
        callback: confirm => {
          if (confirm) {
            this.goBack();
          }
        },
      });
    },
  },
};
</script>
